import * as TYPE from '../types';

const initialState = {
    po_template_settings: [],
    single_po_template_setting: {
        purchase_order_template_id: '',
        template_name: '',
        company_name: '',
        company_address: '',
        company_email: '',
        company_tin: '',
        company_landline: '',
        company_mobile: '',
        is_default: false,
        logo: '',
        logo_preview: '',
        file_logo: null,
        type: '',
        off_default: false
    },
    loading: false,
    show_crop: false,
    crop_trigger: false,
    crop_isset: false,
    show_component: 'main',
}

const purchaseOrderTemplateSettingReducer = (state = initialState, action) => {
    
    switch (action.type) {
        case TYPE.SET_LOADING:
            return {
                ...state,
                loading: action.payload
            }
        case TYPE.SET_PO_COPY_TEMP_MODAL:
            return {
                ...state,
                [action.payload.modal]: action.payload.status
            }
        case TYPE.GET_PO_TEMPLATE_SETTING:
            return {
                ...state,
                po_template_settings: action.payload
            }
        case TYPE.SET_PO_TS_COMPONENT:
            return {
                ...state,
                show_component: action.payload
            }
        case TYPE.HANDLE_PO_TEMPLATE_INPUT:
            return {
                ...state,
                single_po_template_setting: { ...state.single_po_template_setting, [action.payload.name]: action.payload.value }
            }
        case TYPE.HANDLE_SET_PO_DEFAULT_TEMPLATE:
            return {
                ...state,
                single_po_template_setting: { ...state.single_po_template_setting, ...action.payload }
            }
        case TYPE.CLEAR_PO_TEMPLATE_SETTING:
            return {
                ...state,
                single_po_template_setting: {
                    purchase_order_template_id: '',
                    template_name: '',
                    company_name: '',
                    company_address: '',
                    company_email: '',
                    company_landline: '',
                    company_mobile: '',
                    is_default: false,
                    logo: '',
                    logo_preview: '',
                    type: '',
                    file_logo: null,
                    off_default: false
                },
                loading: false,
                show_crop: false,
                crop_trigger: false,
                crop_isset: false,
                show_component: 'main'
            }
        case TYPE.PO_TS_SHOW_CROP:
            return {
                ...state,
                show_crop: action.payload
            }
        case TYPE.PO_TS_LOGO_PREVIEW:
            return {
                ...state,
                single_po_template_setting: { ...state.single_po_template_setting, logo_preview: action.payload },
                show_crop: true
            }
        case TYPE.PO_TS_CROP_LOGO:
            return {
                ...state,
                single_po_template_setting: { ...state.single_po_template_setting, file_logo: action.payload.file_logo },
                crop_trigger: action.payload.crop_trigger
            }
        case TYPE.PO_TS_REMOVE_LOGO:
            return {
                ...state,
                single_po_template_setting: { ...state.single_po_template_setting, ...action.payload }
            }
        case  TYPE.PO_TS_CROP_TRIGGER:
            return {
                ...state,
                crop_trigger: action.payload
            }
        case TYPE.GET_SINGLE_PO_TS:
            return {
                ...state,
                single_po_template_setting: { ...state.single_po_template_setting, ...action.payload }
            }
        case TYPE.PO_TS_CROP_ISSET:
            return {
                ...state,
                crop_isset: action.payload
            }
        default:
            return state;
    }
}


export default purchaseOrderTemplateSettingReducer;